/* unplugin-vue-components disabled */import script from "./FerrymanGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./FerrymanGenerator.vue?vue&type=script&setup=true&lang=js"

import "./FerrymanGenerator.vue?vue&type=style&index=0&id=31dfd8ff&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31dfd8ff"]])

export default __exports__